import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { grirListLayoutRoute } from '..';
import { grirListRouteSearchSchema } from './types';

export const grirListRoute = createRoute({
  getParentRoute: () => grirListLayoutRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./GrirListView')),
  validateSearch: grirListRouteSearchSchema.parse,
});
